import { connect } from 'react-redux';
import { requestEarningsCalculation } from './redux/actionCreators';
import { getEarningsCalculatorState } from './redux/selectors';
var mapStateToProps = function (state) {
    var earningsState = getEarningsCalculatorState(state);
    return {
        estimatedEarningsResponse: earningsState.result,
    };
};
var mapDispatchToProps = {
    requestEarningsCalculation: requestEarningsCalculation,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=EarningsDisplay.container.js.map